/**
 * Progress readout for the batch Go/No-Go AI scoring run.
 *
 * Both functions are pure and take their inputs from persisted assessment state
 * (`aiScoringStage`, `aiScoringStartedAt`) — never from a client-side timer origin.
 * That is what lets progress survive navigating away from the tab and back.
 */

/** Stage → human label. Unknown values degrade to a generic label rather than breaking. */
export function aiScoringStageLabel(stage: string | null, criteriaCount: number): string {
  if (stage == null) return 'Starting…'
  if (stage === 'gathering_evidence') return 'Gathering evidence…'
  if (stage === 'scoring') {
    return `Scoring ${criteriaCount} ${criteriaCount === 1 ? 'criterion' : 'criteria'}…`
  }
  return 'Scoring…'
}

/** "45s" / "1m 12s". `nowMs` is injected so callers stay testable. */
export function formatElapsed(startedAt: string | null, nowMs: number): string | null {
  if (!startedAt) return null
  const startMs = Date.parse(startedAt)
  if (Number.isNaN(startMs)) return null

  const totalSeconds = Math.max(0, Math.floor((nowMs - startMs) / 1000))
  if (totalSeconds < 60) return `${totalSeconds}s`
  return `${Math.floor(totalSeconds / 60)}m ${totalSeconds % 60}s`
}
